import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import { RegisterClient } from '@cloud-twin-v2/generated/simulation.generated.client';
import { DateHelperService } from '@common-modules/shared/helpers/date-helper.service';
import { Observable, map } from 'rxjs';

@Injectable()
export class ModelVersionService extends GeneratedClientManagerService {
  private _client: RegisterClient;

  constructor(private _datesHelper: DateHelperService) {
    super();
    this._client = new RegisterClient(this.httpClient, this.baseUrl);
  }

  deleteSnapshots(instanceId: string, snapshotIds: string[]): Observable<boolean> {
    return this._client.deleteSnapshots(instanceId, snapshotIds).pipe(map(() => true));
  }

  deleteInstance(instanceId: string): Observable<boolean> {
    return this._client.deleteInstance(instanceId).pipe(map(() => true));
  }

  deleteScenarios(
    instanceId: string,
    snapshotId: string,
    scenariosIds: string[]
  ): Observable<boolean> {
    return this._client.deleteScenarios(instanceId, snapshotId, scenariosIds).pipe(map(() => true));
  }
}
